// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WebsiteproofRouteImport } from './routes/websiteproof'
import { Route as WebsiteDesignerNearMeRouteImport } from './routes/website-designer-near-me'
import { Route as WebsiteConciergeWelcomeInformationRouteImport } from './routes/website-concierge-welcome-information'
import { Route as WebsiteCarePlansRouteImport } from './routes/website-care-plans'
import { Route as WebdesignforlifecoachesRouteImport } from './routes/webdesignforlifecoaches'
import { Route as WebdesignforcoachesRouteImport } from './routes/webdesignforcoaches'
import { Route as WebDesignForLifeCoachesRouteImport } from './routes/web-design-for-life-coaches'
import { Route as WebDesignForCoachesRouteImport } from './routes/web-design-for-coaches'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as ThankYouNextStepsRouteImport } from './routes/thank-you-next-steps'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as TermsofpurchasecustomdesignRouteImport } from './routes/termsofpurchasecustomdesign'
import { Route as TermsofpurchaseRouteImport } from './routes/termsofpurchase'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as RealtorWebsiteDesignRouteImport } from './routes/realtor-website-design'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as LawnCareWebsiteDesignRouteImport } from './routes/lawn-care-website-design'
import { Route as KeywordsRouteImport } from './routes/keywords'
import { Route as HomeRouteImport } from './routes/home'
import { Route as GetmylinkRouteImport } from './routes/getmylink'
import { Route as EverybusinessRouteImport } from './routes/everybusiness'
import { Route as DoneForYouCoachingWebsiteRouteImport } from './routes/done-for-you-coaching-website'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ChooseyourcareplanRouteImport } from './routes/chooseyourcareplan'
import { Route as ChinewwebsitespecialRouteImport } from './routes/chinewwebsitespecial'
import { Route as ChinewsitespecialRouteImport } from './routes/chinewsitespecial'
import { Route as ChicagonewwebsitespecialRouteImport } from './routes/chicagonewwebsitespecial'
import { Route as Chicagonewsitespecial2RouteImport } from './routes/chicagonewsitespecial2'
import { Route as ChicagonewsitespecialRouteImport } from './routes/chicagonewsitespecial'
import { Route as ChicagoSmallBusinessWebDesignerRouteImport } from './routes/chicago-small-business-web-designer'
import { Route as CareplantermsRouteImport } from './routes/careplanterms'
import { Route as CallBookedSuccessRouteImport } from './routes/call-booked-success'
import { Route as BookingsuccessRouteImport } from './routes/bookingsuccess'
import { Route as BookingRouteImport } from './routes/booking'
import { Route as BookRouteImport } from './routes/book'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as R1dollarRouteImport } from './routes/1dollar'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminAnalyticsDashboardRouteImport } from './routes/_admin/analytics.dashboard'
import { Route as AdminAdminBlogIndexRouteImport } from './routes/_admin/admin.blog.index'
import { Route as AdminAdminBlogNewRouteImport } from './routes/_admin/admin.blog.new'
import { Route as AdminAdminBlogIdEditRouteImport } from './routes/_admin/admin.blog.$id.edit'

const WebsiteproofRoute = WebsiteproofRouteImport.update({
            id: '/websiteproof',path: '/websiteproof',getParentRoute: () => rootRouteImport
          })
const WebsiteDesignerNearMeRoute = WebsiteDesignerNearMeRouteImport.update({
            id: '/website-designer-near-me',path: '/website-designer-near-me',getParentRoute: () => rootRouteImport
          })
const WebsiteConciergeWelcomeInformationRoute = WebsiteConciergeWelcomeInformationRouteImport.update({
            id: '/website-concierge-welcome-information',path: '/website-concierge-welcome-information',getParentRoute: () => rootRouteImport
          })
const WebsiteCarePlansRoute = WebsiteCarePlansRouteImport.update({
            id: '/website-care-plans',path: '/website-care-plans',getParentRoute: () => rootRouteImport
          })
const WebdesignforlifecoachesRoute = WebdesignforlifecoachesRouteImport.update({
            id: '/webdesignforlifecoaches',path: '/webdesignforlifecoaches',getParentRoute: () => rootRouteImport
          })
const WebdesignforcoachesRoute = WebdesignforcoachesRouteImport.update({
            id: '/webdesignforcoaches',path: '/webdesignforcoaches',getParentRoute: () => rootRouteImport
          })
const WebDesignForLifeCoachesRoute = WebDesignForLifeCoachesRouteImport.update({
            id: '/web-design-for-life-coaches',path: '/web-design-for-life-coaches',getParentRoute: () => rootRouteImport
          })
const WebDesignForCoachesRoute = WebDesignForCoachesRouteImport.update({
            id: '/web-design-for-coaches',path: '/web-design-for-coaches',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const ThankYouNextStepsRoute = ThankYouNextStepsRouteImport.update({
            id: '/thank-you-next-steps',path: '/thank-you-next-steps',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const TermsofpurchasecustomdesignRoute = TermsofpurchasecustomdesignRouteImport.update({
            id: '/termsofpurchasecustomdesign',path: '/termsofpurchasecustomdesign',getParentRoute: () => rootRouteImport
          })
const TermsofpurchaseRoute = TermsofpurchaseRouteImport.update({
            id: '/termsofpurchase',path: '/termsofpurchase',getParentRoute: () => rootRouteImport
          })
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ReviewRoute = ReviewRouteImport.update({
            id: '/review',path: '/review',getParentRoute: () => rootRouteImport
          })
const RealtorWebsiteDesignRoute = RealtorWebsiteDesignRouteImport.update({
            id: '/realtor-website-design',path: '/realtor-website-design',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PortfolioRoute = PortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => rootRouteImport
          })
const LawnCareWebsiteDesignRoute = LawnCareWebsiteDesignRouteImport.update({
            id: '/lawn-care-website-design',path: '/lawn-care-website-design',getParentRoute: () => rootRouteImport
          })
const KeywordsRoute = KeywordsRouteImport.update({
            id: '/keywords',path: '/keywords',getParentRoute: () => rootRouteImport
          })
const HomeRoute = HomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => rootRouteImport
          })
const GetmylinkRoute = GetmylinkRouteImport.update({
            id: '/getmylink',path: '/getmylink',getParentRoute: () => rootRouteImport
          })
const EverybusinessRoute = EverybusinessRouteImport.update({
            id: '/everybusiness',path: '/everybusiness',getParentRoute: () => rootRouteImport
          })
const DoneForYouCoachingWebsiteRoute = DoneForYouCoachingWebsiteRouteImport.update({
            id: '/done-for-you-coaching-website',path: '/done-for-you-coaching-website',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ChooseyourcareplanRoute = ChooseyourcareplanRouteImport.update({
            id: '/chooseyourcareplan',path: '/chooseyourcareplan',getParentRoute: () => rootRouteImport
          })
const ChinewwebsitespecialRoute = ChinewwebsitespecialRouteImport.update({
            id: '/chinewwebsitespecial',path: '/chinewwebsitespecial',getParentRoute: () => rootRouteImport
          })
const ChinewsitespecialRoute = ChinewsitespecialRouteImport.update({
            id: '/chinewsitespecial',path: '/chinewsitespecial',getParentRoute: () => rootRouteImport
          })
const ChicagonewwebsitespecialRoute = ChicagonewwebsitespecialRouteImport.update({
            id: '/chicagonewwebsitespecial',path: '/chicagonewwebsitespecial',getParentRoute: () => rootRouteImport
          })
const Chicagonewsitespecial2Route = Chicagonewsitespecial2RouteImport.update({
            id: '/chicagonewsitespecial2',path: '/chicagonewsitespecial2',getParentRoute: () => rootRouteImport
          })
const ChicagonewsitespecialRoute = ChicagonewsitespecialRouteImport.update({
            id: '/chicagonewsitespecial',path: '/chicagonewsitespecial',getParentRoute: () => rootRouteImport
          })
const ChicagoSmallBusinessWebDesignerRoute = ChicagoSmallBusinessWebDesignerRouteImport.update({
            id: '/chicago-small-business-web-designer',path: '/chicago-small-business-web-designer',getParentRoute: () => rootRouteImport
          })
const CareplantermsRoute = CareplantermsRouteImport.update({
            id: '/careplanterms',path: '/careplanterms',getParentRoute: () => rootRouteImport
          })
const CallBookedSuccessRoute = CallBookedSuccessRouteImport.update({
            id: '/call-booked-success',path: '/call-booked-success',getParentRoute: () => rootRouteImport
          })
const BookingsuccessRoute = BookingsuccessRouteImport.update({
            id: '/bookingsuccess',path: '/bookingsuccess',getParentRoute: () => rootRouteImport
          })
const BookingRoute = BookingRouteImport.update({
            id: '/booking',path: '/booking',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/_admin',getParentRoute: () => rootRouteImport
          })
const R1dollarRoute = R1dollarRouteImport.update({
            id: '/1dollar',path: '/1dollar',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const AdminAnalyticsDashboardRoute = AdminAnalyticsDashboardRouteImport.update({
            id: '/analytics/dashboard',path: '/analytics/dashboard',getParentRoute: () => AdminRoute
          })
const AdminAdminBlogIndexRoute = AdminAdminBlogIndexRouteImport.update({
            id: '/admin/blog/',path: '/admin/blog/',getParentRoute: () => AdminRoute
          })
const AdminAdminBlogNewRoute = AdminAdminBlogNewRouteImport.update({
            id: '/admin/blog/new',path: '/admin/blog/new',getParentRoute: () => AdminRoute
          })
const AdminAdminBlogIdEditRoute = AdminAdminBlogIdEditRouteImport.update({
            id: '/admin/blog/$id/edit',path: '/admin/blog/$id/edit',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminAnalyticsDashboardRoute: AdminAnalyticsDashboardRoute,AdminAdminBlogNewRoute: AdminAdminBlogNewRoute,AdminAdminBlogIndexRoute: AdminAdminBlogIndexRoute,AdminAdminBlogIdEditRoute: AdminAdminBlogIdEditRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,R1dollarRoute: R1dollarRoute,AdminRoute: AdminRouteWithChildren,AboutRoute: AboutRoute,BookRoute: BookRoute,BookingRoute: BookingRoute,BookingsuccessRoute: BookingsuccessRoute,CallBookedSuccessRoute: CallBookedSuccessRoute,CareplantermsRoute: CareplantermsRoute,ChicagoSmallBusinessWebDesignerRoute: ChicagoSmallBusinessWebDesignerRoute,ChicagonewsitespecialRoute: ChicagonewsitespecialRoute,Chicagonewsitespecial2Route: Chicagonewsitespecial2Route,ChicagonewwebsitespecialRoute: ChicagonewwebsitespecialRoute,ChinewsitespecialRoute: ChinewsitespecialRoute,ChinewwebsitespecialRoute: ChinewwebsitespecialRoute,ChooseyourcareplanRoute: ChooseyourcareplanRoute,ContactRoute: ContactRoute,DoneForYouCoachingWebsiteRoute: DoneForYouCoachingWebsiteRoute,EverybusinessRoute: EverybusinessRoute,GetmylinkRoute: GetmylinkRoute,HomeRoute: HomeRoute,KeywordsRoute: KeywordsRoute,LawnCareWebsiteDesignRoute: LawnCareWebsiteDesignRoute,PortfolioRoute: PortfolioRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RealtorWebsiteDesignRoute: RealtorWebsiteDesignRoute,ReviewRoute: ReviewRoute,ServicesRoute: ServicesRoute,TermsAndConditionsRoute: TermsAndConditionsRoute,TermsofpurchaseRoute: TermsofpurchaseRoute,TermsofpurchasecustomdesignRoute: TermsofpurchasecustomdesignRoute,ThankYouRoute: ThankYouRoute,ThankYouNextStepsRoute: ThankYouNextStepsRoute,UnsubscribeRoute: UnsubscribeRoute,WebDesignForCoachesRoute: WebDesignForCoachesRoute,WebDesignForLifeCoachesRoute: WebDesignForLifeCoachesRoute,WebdesignforcoachesRoute: WebdesignforcoachesRoute,WebdesignforlifecoachesRoute: WebdesignforlifecoachesRoute,WebsiteCarePlansRoute: WebsiteCarePlansRoute,WebsiteConciergeWelcomeInformationRoute: WebsiteConciergeWelcomeInformationRoute,WebsiteDesignerNearMeRoute: WebsiteDesignerNearMeRoute,WebsiteproofRoute: WebsiteproofRoute,AdminLoginRoute: AdminLoginRoute,BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)